import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  createDesignation,
  getDesignationDetail,
  updateDesignation,
} from "../../../../services/workspace/designation.service";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { useFormik } from "formik";
import DefaultInput from "../../inputs/defaultInput";
import DefaultTextarea from "../../inputs/defaultTextarea";
import DefaultButton from "../../buttons/defaultButton";
import DefaultSearchSelectInput from "../../inputs/defaultSearchSelectInput";
import Loading from "../../skeleton/loading";
import {
  _transformPayload,
  convertToLabelValue,
} from "../../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import {
  _fetchDepartments,
  _fetchDesignations,
  _fetchRoles,
} from "../../../../store/actions/configuration";
import { _updateDesignation } from "../../../../store/slices/baseSetup.slice";
import { verifyVerificationOTP } from "../../../../services/workspace/user.service";

const validationSchema = Yup.object().shape({
  otp: Yup.string()
    .trim()
    .length(6, "OTP must be 6 digits")
    .required("OTP is required."),
});

const VerifyEmailForm = ({
  isModal = false,
  closeModal = () => null,
  isSubmitting = false,
  setIsSubmitting = () => null,
  sendEmailVerification = () => null,
  sendPhoneVerification = () => null,
  countdown = 0,
  resendDisabled = false,
  setIsEmailVerified = () => null,
  setIsPhoneVerified = () => null,
  email = "",
  phone = "",
  type = "",
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([...Array(6)].map(() => React.createRef()));

 

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setIsSubmitting(true);
    //   const payload = _transformPayload(values);
      // const payload = {
      //   otp: values.otp,
      //   type: "email",
      //   email: email,
      // };

    
      let payload = {
        otp: values.otp,
      }

      if(type === "EMAIL"){
        payload.type = "email";
        payload.email = email;
      }else if(type === "PHONE"){
        payload.type = "phone";
        payload.phone = phone;
      }

      try {
        // Handle OTP verification logic here
        verifyVerificationOTP(payload).then((res) => {
            if(res.status === 200 && res.data.status){
                toast.success("OTP verified successfully!");
                if(type === "EMAIL"){
                    setIsEmailVerified(true);
                }else if(type === "PHONE"){
                    setIsPhoneVerified(true);
                }
                setIsSubmitting(false);
                if (isModal) {
                    closeModal();
                } else {
                    if(type === "EMAIL"){
                        setIsEmailVerified(false);
                    }else if(type === "PHONE"){
                        setIsPhoneVerified(false);
                    }
                    // Navigate to next page after verification
                }
            }else{
                toast.error("Invalid OTP!");

                setIsSubmitting(false);
            }
       
      });
      } catch (error) {
        toast.error("Invalid OTP!");
        setIsSubmitting(false);
      } finally {
        setIsSubmitting(false);
        
      }
    },
  });

  const handleOtpChange = (index, value) => {
    // Allow only numbers
    if (!/^\d*$/.test(value)) return;

    const newOtpDigits = [...otpDigits];
    newOtpDigits[index] = value;
    setOtpDigits(newOtpDigits);

    // Set the combined OTP value in formik
    const combinedOtp = newOtpDigits.join("");
    setFieldValue("otp", combinedOtp);

    // Auto focus to next input
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // On backspace, clear current field and move to previous field
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");
    if (!pastedData.match(/^\d+$/)) return;

    const digits = pastedData.slice(0, 6).split("");
    const newOtpDigits = [...otpDigits];

    digits.forEach((digit, index) => {
      if (index < 6) {
        newOtpDigits[index] = digit;
      }
    });

    setOtpDigits(newOtpDigits);
    setFieldValue("otp", newOtpDigits.join(""));

    // Focus on the next empty field or the last field
    const nextEmptyIndex = newOtpDigits.findIndex((digit) => !digit);
    if (nextEmptyIndex !== -1 && nextEmptyIndex < 6) {
      inputRefs.current[nextEmptyIndex].focus();
    } else if (digits.length < 6) {
      inputRefs.current[digits.length].focus();
    } else {
      inputRefs.current[5].focus();
    }
  };

  // For mobile devices - handle focusing on input touch
  const handleInputFocus = (index) => {
    inputRefs.current[index].focus();
  };

  const handleResendOTP = () => {
    if (!resendDisabled) {
      if(type === "EMAIL"){
        sendEmailVerification();
      }else if(type === "PHONE"){
        sendPhoneVerification();
      }
    //   startResendTimer();
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div
          className={`bg-white ${isModal ? "p-0" : "p-4"} flex flex-col gap-4`}
        >
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col items-center gap-6">
              <div className="flex flex-col items-center">
                <h2 className="text-primary-800 text-xl font-semibold">
                  {type === "EMAIL" ? "Email Verification" : "Phone Verification"}
                </h2>
                <span className="text-gray-600 text-center">
                  Enter the 6-digit OTP sent to your {type === "EMAIL" ? "email address" : "phone number"}
                </span>
              </div>

              <div className="flex flex-col items-center gap-4">
                <div className="w-full">
                  <div className="hidden">
                    <DefaultInput
                      name="otp"
                      value={values.otp}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error=""
                    />
                  </div>

                  <div className="flex flex-col gap-2">
                    <div className="flex justify-center gap-2">
                      {otpDigits.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength={1}
                          value={digit}
                          ref={(el) => (inputRefs.current[index] = el)}
                          onChange={(e) =>
                            handleOtpChange(index, e.target.value)
                          }
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          onPaste={index === 0 ? handlePaste : null}
                          onClick={() => handleInputFocus(index)}
                          className={`flex-1 text-center w-10 max-w-10 h-10 ring-0 focus:ring-0 focus:shadow-none focus:border-borderColor text-lg font-semibold rounded-md border-0 bg-light focus:bg-light ${
                            touched.otp && errors.otp
                              ? "bg-red-100 border border-red-200"
                              : ""
                          }`}
                        />
                      ))}
                    </div>

                    {touched.otp && errors.otp && (
                      <div className="flex justify-center">
                        <span className="flex items-center text-sm text-error-600">
                          {errors.otp}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <DefaultButton
                    variant="default"
                    name={"Verify OTP"}
                    type="submit"
                    loading={isSubmitting}
                  />
                  {isModal ? (
                    <DefaultButton
                      variant="secondary"
                      name={"Cancel"}
                      onClick={closeModal}
                    />
                  ) : null}
                </div>
              </div>
              <div className="flex flex-col items-center gap-2">
                <span className="text-gray-600 text-center">
                  Didn't receive the OTP?
                </span>
                <div className="text-center text-sm text-gray-600 text-xs">
                  Check your spam folder or request a new one
                </div>
                <button
                  type="button"
                  onClick={handleResendOTP}
                  className={`text-sm ${
                    resendDisabled
                      ? "text-gray-400 cursor-not-allowed"
                      : "text-textLight hover:text-primary-700 hover:underline"
                  }`}
                  disabled={resendDisabled || isSubmitting}
                  loading={isSubmitting}
                >
                  {resendDisabled
                    ? `Resend OTP in ${countdown}s`
                    : "Resend OTP"}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default VerifyEmailForm;
